import { getStorage } from 'firebase/storage'; // Correct import
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './EditVibeTool.css';
import editvibelogo1 from '../assets/Editvibelogo1.svg';
import defaultAvatar from '../assets/default-avatar.png';
import vidIcon from '../assets/vid.svg';
import aistars from '../assets/aistars.svg';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { GoGear } from 'react-icons/go';
import { BsTicketPerforated } from "react-icons/bs";
import { IoTicketOutline } from "react-icons/io5";
import { LuLogOut } from "react-icons/lu";
import { TfiVideoClapper } from 'react-icons/tfi';
import { db, storage } from '../auth';
import { getAuth } from "firebase/auth";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { collection, addDoc, onSnapshot, query, where, doc, updateDoc, deleteDoc, increment, writeBatch } from "firebase/firestore";
import icons8Plus1 from '../assets/icons8-plus1.svg';
import { RiScissorsCutLine } from "react-icons/ri";
import { PiFilmSlateLight } from "react-icons/pi";  
import editvibe95tutorial from '../assets/editvibe95tutorial.mp4';
import editvibecuttutorial from '../assets/editvibecuttutorial.mp4';
import { IoMdDownload } from "react-icons/io";
import { FaRegTrashCan } from "react-icons/fa6";
import useTypingEffect from '../hooks/useTypingEffect'

/** Helper function to verify file is a video and under 2 minutes. */
function checkVideoFile(file) {
  return new Promise((resolve) => {
    if (!file.type.startsWith('video/')) {
      resolve({ valid: false, error: 'Not a video file.' });
      return;
    }
    const videoEl = document.createElement('video');
    videoEl.preload = 'metadata';
    videoEl.onloadedmetadata = () => {
      window.URL.revokeObjectURL(videoEl.src);
      const duration = videoEl.duration;
      if (duration <= 120) {
        resolve({ valid: true, duration });
      } else {
        resolve({ valid: false, error: 'Video is longer than 2 minutes.' });
      }
    };
    videoEl.onerror = () => {
      resolve({ valid: false, error: 'Could not load video metadata.' });
    };
    videoEl.src = URL.createObjectURL(file);
  });
}

function EditVibeTool({ user, logout, userData }) {
  const [videoFile, setVideoFile] = useState(null);
  const [videoDuration, setVideoDuration] = useState(0);
  const [videoPreview, setVideoPreview] = useState('');
  const [uploadError, setUploadError] = useState('');
  const [persistedVideos, setPersistedVideos] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [isVideoOverlayOpen, setIsVideoOverlayOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [textInput, setTextInput] = useState(''); // For the user's edit request
  const textareaRef = useRef(null);

 // auto‑resize textarea whenever textInput changes
 useEffect(() => {
   if (textareaRef.current) {
     textareaRef.current.style.height = 'auto';
     textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
   }
 }, [textInput]);
  const [isModelMenuOpen, setIsModelMenuOpen] = useState(false);
  const [selectedModel, setSelectedModel] = useState('editvibeTool');
  const [showInitialLoading, setShowInitialLoading] = useState(false); // For the 10-second loading overlay
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const handleAvatarClick = () => setIsUserMenuOpen(!isUserMenuOpen);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isDescribeOpen, setIsDescribeOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [videoToDelete, setVideoToDelete] = useState(null);
const [showFinalDeleteModal, setShowFinalDeleteModal] = useState(false);
const [showTranscriptionErrorModal, setShowTranscriptionErrorModal] = useState(false);
const [showTimecodeErrorModal, setShowTimecodeErrorModal] = useState(false);
const [showSaveConfirmModal, setShowSaveConfirmModal] = useState(false);
const TWO_GB = 2 * 1024 * 1024 * 1024;
const EDIT_COST = 25;
const [toolTutorialOpen,  setToolTutorialOpen]  = useState(false);
const [toolTutorialModal, setToolTutorialModal] = useState(null);

// mirror your Layout’s helpers:
const showToolTutorial = (which) => {
  setToolTutorialModal(which);      // “95” or “cut”
  setToolTutorialOpen(false);      // close the sub‑menu
  setIsUserMenuOpen(false);        // close the user menu
};

const closeToolTutorialModal = () => {
  setToolTutorialModal(null);
};



const placeholderMessage = "Remove the part where the speaker says 'I think I messed that up'";
const [placeholder, setPlaceholder] = useState("");


const handleCloseTranscriptionErrorModal = () => {
  setShowTranscriptionErrorModal(false);
};

const handleCloseTimecodeErrorModal = () => {
  // Hide the timecode error modal…
  setShowTimecodeErrorModal(false);
  // Hide the describe overlay so that the text input container appears
  setIsDescribeOpen(false);
  // Update the selected video’s status so that the user input screen renders.
  // For instance, by setting status to "ready_for_edits"
  setSelectedVideo((prev) => ({ ...prev, status: "ready_for_edits" }));
};

const messages = [
  'EditVibe crafts your video masterpiece now',
  'Our AI sculpts your footage to perfection!',
  'Production quality review is underway now!',
  // …etc
];
const [msgIndex, setMsgIndex] = useState(0);
const { text: typingText, isAnimating } = useTypingEffect(messages[msgIndex]);

useEffect(() => {
  if (!isAnimating) {
    const t = setTimeout(() => {
      setMsgIndex((msgIndex + 1) % messages.length);
    }, 1000);
    return () => clearTimeout(t);
  }
}, [isAnimating, msgIndex]);


const handleFinalConfirmDelete = async () => {
  if (!videoToDelete) return;
  try {
    // First, download the file as a backup if desired
    if (videoToDelete.videoURL) {
      await handleDownload(videoToDelete.videoURL, videoToDelete.videoName);
    }
    // Then delete the file from Storage.
    const storageRefToDelete = ref(
      storage,
      `EditVibeToolVideos/${user.uid}/${videoToDelete.firebaseFileName}`
    );
    await deleteObject(storageRefToDelete);
    
    // Delete the Firestore document.
    await deleteDoc(doc(db, "EditVibeToolVideos", videoToDelete.id));
    
    // Update the local UI state.
    setPersistedVideos((prev) =>
      prev.filter((video) => video.id !== videoToDelete.id)
    );
    setSelectedVideo(null);
    setIsVideoOverlayOpen(false);
  } catch (error) {
    console.error("Error in final delete:", error);
    alert("Error deleting video. Please try again.");
  } finally {
    setShowFinalDeleteModal(false);
    setVideoToDelete(null);
  }
};

const handleCancelFinalDelete = () => {
  setShowFinalDeleteModal(false);
  setVideoToDelete(null);
};

// Call this when the user clicks cancel in the modal.
const handleCancelDelete = () => {
  setShowDeleteModal(false);
  setVideoToDelete(null);
};

// This function performs the deletion from storage and Firestore.
const handleConfirmDelete = async () => {
  if (!videoToDelete) return;
  try {
    
    // Create a reference to the file in Firebase Storage.
    const storageRefToDelete = ref(
      storage,
      `EditVibeToolVideos/${user.uid}/${videoToDelete.firebaseFileName}`
    );
    // Delete the file from Storage.
    await deleteObject(storageRefToDelete);
    
    // Delete the document from Firestore.
    await deleteDoc(doc(db, "EditVibeToolVideos", videoToDelete.id));
    
    // Remove the video from your local state so it no longer appears in the UI.
    setPersistedVideos((prev) =>
      prev.filter((video) => video.id !== videoToDelete.id)
    );
    setSelectedVideo(null);
    setIsVideoOverlayOpen(false);
  } catch (error) {
    console.error("Error confirming deletion:", error);
    alert("Error deleting video. Please try again.");
  } finally {
    setShowDeleteModal(false);
    setVideoToDelete(null);
  }
};

  const proceedToDescribe = () => {
    setIsUploadOpen(false);    // hide the upload file modal
    setIsDescribeOpen(true);   // show the new screen with thumbnail and submit button
  };

  const getVideoByMenuKey = (menuKey) => {
    // Assuming your menu keys are in the format "tool-<videoId>"
    const videoId = menuKey.replace("tool-", "");
    return persistedVideos.find((video) => video.id === videoId);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (!user) {
      navigate("/");
    }
  }, [user, navigate]);

  // ---------------------------
  // UPLOAD / UPDATE FUNCTIONS
  // ---------------------------

  // Function to upload the original video and create its Firestore document.
  // We now also store the original video URL and name.
  const handleSubmitDescription = async () => {
    if (!videoFile) {
      alert("No video file selected.");
      return;
    }
    setIsSubmitting(true);
    closeUploadFlow(); // Hides the upload modal right away
    try {
      const uniqueFileName = `${user.uid.slice(0, 8)}_${Date.now().toString(36)}.mp4`;
      const storageRef = ref(storage, `EditVibeToolVideos/${user.uid}/${uniqueFileName}`);
      
      // Upload file to Firebase Storage.
      await uploadBytes(storageRef, videoFile);
      const downloadURL = await getDownloadURL(storageRef);
  
      const videosCol = collection(db, "EditVibeToolVideos");
      await addDoc(videosCol, {
        userId: user.uid,
        videoURL: downloadURL,
        videoName: videoFile.name,
        firebaseFileName: uniqueFileName,
        createdAt: new Date(),
        status: "original",
        // Store original details so we can revert later if needed.
        originalVideoURL: downloadURL,
        originalVideoName: videoFile.name,
        cost: EDIT_COST
      });
  
      // If you need the extra 2 seconds delay for display purposes, you can add a delay here
    await new Promise((resolve) => setTimeout(resolve, 2000));

    // (Optionally) You can remove any alerts here so nothing is shown
    // alert("Video uploaded successfully!");
    
    // If you have any post-upload actions, do them here

  } catch (error) {
    console.error("Error uploading video:", error);
    alert("Something went wrong. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};

  const [menuOpenFor, setMenuOpenFor] = useState(null);

  const handleMenuToggle = (key, e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setMenuPosition({ top: rect.top, left: rect.right });
    setMenuOpenFor(prev => (prev === key ? null : key));
  };
  
  const handleDeleteVideo = async (vidId, e) => {
    e.stopPropagation();
    try {
      // Find the video object in your persistedVideos array using the video ID.
      const videoToDelete = persistedVideos.find((video) => video.id === vidId);
      if (!videoToDelete) {
        console.error("Video not found");
        return;
      }
      
      // Create a reference to the file in Firebase Storage.
      // Adjust the path if needed. Here we assume you store files under "EditVibeToolVideos/<user.uid>/<firebaseFileName>".
      const storageRefToDelete = ref(storage, `EditVibeToolVideos/${user.uid}/${videoToDelete.firebaseFileName}`);
      
      // Delete the file from Storage.
      await deleteObject(storageRefToDelete);
      
      // Delete the Firestore document.
      await deleteDoc(doc(db, "EditVibeToolVideos", vidId));
      
      // Update your local state so that the UI removes this video.
      setPersistedVideos(prev => prev.filter(video => video.id !== vidId));
      setMenuOpenFor(null);
    } catch (err) {
      console.error("Error deleting video:", err);
      alert("Error deleting video. Please try again.");
    }
  };
  
  const handleDownload = async (url, filename) => {
  try {

     // make sure our download name ends in .mp4
     const safeName = filename.toLowerCase().endsWith('.mp4')
     ? filename
     : `${filename}.mp4`;

    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = safeName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("Download error", err);
  }
};

  // Function to update the selected video document after FFmpeg processing.
  // It updates the videoURL, appends " EDITED" to the videoName, and sets status to "edited".
  const updateVideoDocument = async (finalVideoURL) => {
    if (!selectedVideo || !selectedVideo.id) return;
    try {
      const videoDoc = doc(db, "EditVibeToolVideos", selectedVideo.id);
      
      // Clean the current videoName by removing any " EDITED" text first.
      const cleanedName = selectedVideo.videoName.replace(/ EDITED/g, "").trim();
      
      // Remove any trailing version pattern " V<number>" from the cleaned name.
      const baseName = cleanedName.replace(/ V\d+$/, "").trim();
      
      // Extract the current version number from the cleaned name.
      const versionMatch = cleanedName.match(/ V(\d+)$/);
      const currentVersion = versionMatch ? parseInt(versionMatch[1], 10) : 0;
      const newVersion = currentVersion + 1;
      const newVideoName = `${baseName} V${newVersion}`;
      
      await updateDoc(videoDoc, {
        previousVideoURL: selectedVideo.videoURL,
        previousVideoName: selectedVideo.videoName,
        videoURL: finalVideoURL,
        videoName: newVideoName,
        status: "edited",
      });
      console.log("Video document updated in Firestore.");
      
      // Update local state with the new version name and URL.
      setSelectedVideo(prev => ({
        ...prev,
        previousVideoURL: prev.videoURL,
        previousVideoName: prev.videoName,
        videoURL: finalVideoURL,
        videoName: newVideoName,
        status: "edited"
      }));
    } catch (err) {
      console.error("Failed to update video document:", err);
    }
  };
  
  

  // ---------------------------
  // REAL-TIME FIRESTORE LISTENER
  // ---------------------------
  useEffect(() => {
    if (user) {
      const videosQuery = collection(db, "EditVibeToolVideos");
      const userVideosQuery = query(videosQuery, where("userId", "==", user.uid));
      const unsubscribe = onSnapshot(userVideosQuery, (snapshot) => {
        const vids = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));
        setPersistedVideos(vids);
      });
      return () => unsubscribe();
    }
  }, [user]);

  // ---------------------------
  // HANDLER FUNCTIONS FOR UPLOAD & SELECTION
  // ---------------------------
  const openUploadModal = () => {
    // Close the video overlay and model menu, and clear any selected video.
    setIsVideoOverlayOpen(false);
    setIsModelMenuOpen(false);
    setSelectedVideo(null);
  
    // Open the upload modal.
    setIsUploadOpen(true);
    setVideoFile(null);
    setVideoPreview('');
    setUploadError('');
  };

  const closeUploadFlow = () => {
    setIsUploadOpen(false);
    setIsDescribeOpen(false);
    setVideoFile(null);
    setVideoPreview('');
    setUploadError('');
  };

  const handleFileChange = async (e) => {
    if (!e.target.files[0]) return;
    const file = e.target.files[0];
    await handleVideoFile(file);
  };

  const dropHandler = async (e) => {
    e.preventDefault();
    if (!e.dataTransfer.files[0]) return;
    const file = e.dataTransfer.files[0];
    await handleVideoFile(file);
  };


const handleVideoFile = async (file) => {
  setUploadError('');

  // 1) Enforce 2 GB size limit
  if (file.size > TWO_GB) {
    setUploadError('File is larger than 2 GB. Please select a smaller file.');
    return;
  }

  // 2) Then check that it’s truly a valid video under your duration limit
  const { valid, duration, error } = await checkVideoFile(file);
  if (!valid) {
    setUploadError(error || 'Invalid file.');
    return;
  }

  // 3) If all good, proceed
  setVideoFile(file);
  setVideoDuration(duration || 0);
  setVideoPreview(URL.createObjectURL(file));
  proceedToDescribe();
};
  const handleVideoItemClick = (vid) => {
    setIsUploadOpen(false);      // Close upload modal if it's open.
    setIsModelMenuOpen(false);     // Close the model menu.
    setSelectedVideo(vid);
    setIsVideoOverlayOpen(true);
  };

  const closeVideoOverlay = () => {
    setIsVideoOverlayOpen(false);
    // Do not clear selectedVideo here if you want it to persist until a different item is clicked.
  };

  const handleModelClick = () => {
    setIsUploadOpen(false);
    setIsVideoOverlayOpen(false);
    setSelectedVideo(null); // Clear the selected video to hide user input.
    setIsModelMenuOpen(!isModelMenuOpen);
  };
  
  const selectModel = (model) => {
    console.log('Model Selected:', model);
    setSelectedModel(model);
    setIsModelMenuOpen(false);
    if (model === 'editvibeTool') {
      console.log('Staying in EditVibe Tool');
    }
    if (model === 'm1') {
      console.log('Navigating to the home page (EditVibeLayout)');
      navigate("/");
    }
  };

  useEffect(() => {
    setPlaceholder("");
  }, [selectedVideo?.id]);

  // 5) Type one character at a time
  useEffect(() => {
    if (placeholder.length >= placeholderMessage.length) return;

    const timeout = setTimeout(() => {
      // slice up to +1 character
      setPlaceholder( placeholderMessage.slice(0, placeholder.length + 1) );
    }, 75);

    return () => clearTimeout(timeout);
  }, [placeholder, placeholderMessage]);

  // ---------------------------
  // HANDLER FOR TEXT SUBMISSION (EDIT REQUEST)
  // ---------------------------
  const handleTextSubmit = async () => {
      // ─── NEGATIVE-CREDIT GUARD ─────────────────────────────────────
  if (userData?.credits < EDIT_COST) {
    alert("Insufficient credits. Please upgrade your plan to add more credits.");
    openManagePlan();         // pop open your “choose a plan” modal
    return;                   // abort everything else
  }
  // ────────────────────────────────────────────────────────────────

    if (!selectedVideo || !textInput) {
      alert("Please select a video and provide your input.");
      return;
    }

    setSelectedVideo(prev => ({ ...prev, status: "processing" }));
  
    // Show the loading overlay.
    setShowInitialLoading(true);
    setTimeout(() => {
      setShowInitialLoading(false);
    }, 10000);
  
    // 1. Update the selected document to mark it as processing.
    await updateDoc(doc(db, "EditVibeToolVideos", selectedVideo.id), {
      status: "processing"
    });
  
    // 2. Use the original firebaseFileName from the selected video.
    const originalFirebaseFileName = selectedVideo.firebaseFileName;
  
    try {
      // 3. Construct the transcription JSON path.
      const transcriptionPath = `EditVibeToolMP3/${originalFirebaseFileName.replace(".mp4", ".json")}`;
      const transcriptionRef = ref(storage, transcriptionPath);
      console.log("User Input:", textInput);
  
      // 4. Retrieve the transcription JSON.
      const transcriptionURL = await getDownloadURL(transcriptionRef);
      const response = await fetch(transcriptionURL);
      const transcriptionJson = await response.json();
      console.log("Transcription JSON:", transcriptionJson);
  
      // 5. Prepare and send the request to OpenAI.
      const openAiData = {
        model: "gpt-4o-mini",
        messages: [
          {
            role: "system",
            content: `You are a video editing assistant. Your task is to analyze a user request and a list of word-level timecodes extracted from a video transcription. Identify all parts of the video that match the user's request—even if there are misspellings or slight variations—and return as many matching segments as you find. Your response must be a JSON array of objects in the following format:
      [
        {"start": <start_time_in_seconds>, "end": <end_time_in_seconds>},
        ...
      ]
      Return only the JSON array with no additional explanation. If no segments match, return an empty array.`
          },
          {
            role: "user",
            content: `
      User Request: "${textInput}"
      Transcription: ${JSON.stringify(transcriptionJson)}
      `
          }
        ],
        max_completion_tokens: 1000,
        top_p: 1,
      };
  
      const idToken = await getAuth().currentUser.getIdToken();
const openAiResponse = await fetch("/openai/v1/chat/completions", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${idToken}`,
  },
  body: JSON.stringify(openAiData),
});
  
      const openAiResult = await openAiResponse.json();
      if (openAiResult.error) {
        console.error("OpenAI Error:", openAiResult.error);
      } else {
        console.log("OpenAI Response:", openAiResult);
      }
  
      // 6. Extract and parse the timecodes.
      const timecodes =
        openAiResult.choices && openAiResult.choices[0]?.message?.content;
      if (timecodes) {
        console.log("Generated Timecodes:", timecodes);
        let timeRanges;
        try {
          const cleanTimecodes = timecodes
            .replace(/```json\s*/, "")
            .replace(/\s*```$/, "");
          timeRanges = JSON.parse(cleanTimecodes);
        } catch (err) {
          console.error("Error parsing timecodes:", err);
          console.error("Error parsing timecodes:", err);
          // When JSON cannot be parsed, treat it as no valid timecodes
          await updateDoc(doc(db, "EditVibeToolVideos", selectedVideo.id), {
            status: "ready_for_edits"
          });
          setSelectedVideo(prev => ({ ...prev, status: "ready_for_edits" }));
          setShowTimecodeErrorModal(true);
          return;
        }
        // If timeRanges is empty or not as expected…
        if (!timeRanges || timeRanges.length === 0) {
          console.error("No timecodes found in the response.");
          await updateDoc(doc(db, "EditVibeToolVideos", selectedVideo.id), {
            status: "ready_for_edits"
          });
          setSelectedVideo(prev => ({ ...prev, status: "ready_for_edits" }));
          setShowTimecodeErrorModal(true);
          return;
        }
   // 0) Record the cost onto that video document
   await updateDoc(
    doc(db, "EditVibeToolVideos", selectedVideo.id),
    { cost: EDIT_COST }
  );
         // **** NEW: atomically deduct credits—and record which video & cost—so rules can verify it ****
 const batch     = writeBatch(db);
 const userRef   = doc(db, "users", user.uid);
 // 1) subtract credits, 2) record lastDeductedVideo & lastDeductedCost
 batch.update(userRef, {
   credits:            increment(-EDIT_COST),
   lastDeductedVideo:  selectedVideo.id,
   lastDeductedCost:   EDIT_COST
 });
 await batch.commit();
  
        // 7. Construct the full storage path of the original video.
        const videoFilePath = `EditVibeToolVideos/${user.uid}/${selectedVideo.firebaseFileName}`;
  
        // 8. Prepare the request body for the Cloud Function.
        const requestBody = {
          videoFilePath,
          firebaseFileName: selectedVideo.firebaseFileName,
          timeRanges,
        };
  
        // 9. Call the Cloud Function to process the video.
        const processVideoResponse = await fetch(
          "https://us-central1-editvibe-90968.cloudfunctions.net/processVideoSegments",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestBody),
          }
        );
        const processVideoResult = await processVideoResponse.json();
        if (processVideoResult.error) {
          console.error("Error processing video:", processVideoResult.error);
        } else if (processVideoResult.finalVideoPath) {
          console.log("Video processed successfully.");
          console.log("Final video path:", processVideoResult.finalVideoPath);
          // 10. Convert the final video storage path to a full download URL.
          const finalVideoRef = ref(storage, processVideoResult.finalVideoPath);
          const finalVideoURL = await getDownloadURL(finalVideoRef);
          console.log("Final video download URL:", finalVideoURL);
  
          // 11. Update the same document with the final video URL, append " EDITED" to the name, and set status to "edited".
          await updateVideoDocument(finalVideoURL);
  
          // 12. Update local state so that the sidebar shows the updated video.
          if (selectedVideo && selectedVideo.id) {
            setSelectedVideo(prev => ({
              ...prev,
              videoURL: finalVideoURL,
              videoName: prev.videoName,
              status: "edited"
            }));
          }
        }
      } else {
        console.error("Error: No timecodes found in the response.");
        await updateDoc(doc(db, "EditVibeToolVideos", selectedVideo.id), {
          status: "ready_for_edits"
        });
        setSelectedVideo(prev => ({ ...prev, status: "ready_for_edits" }));
        setShowTimecodeErrorModal(true);
        return;
      }
  
    } catch (error) {
      console.error("Error fetching transcription or interacting with OpenAI:", error);
      // Update the Firestore document to mark the video as ready for edits
      await updateDoc(doc(db, "EditVibeToolVideos", selectedVideo.id), {
        status: "ready_for_edits"
      });
      // Update local state so that the video status causes the user input to display
      setSelectedVideo(prev => ({
        ...prev,
        status: "ready_for_edits"
      }));
      // Show the transcription error modal
      setShowTranscriptionErrorModal(true);
    }
  };

  // New functions for DELETE and SAVE buttons for final videos
  const handleDelete = async () => {
    if (!selectedVideo || !selectedVideo.id) return;
    try {
      // Use previous version if it exists; otherwise, fall back to original.
      const newVideoURL = selectedVideo.previousVideoURL || selectedVideo.originalVideoURL;
      const newVideoName = selectedVideo.previousVideoName || selectedVideo.originalVideoName;
  
      await updateDoc(doc(db, "EditVibeToolVideos", selectedVideo.id), {
        videoURL: newVideoURL,
        videoName: newVideoName,
        status: newVideoURL === selectedVideo.originalVideoURL ? "original" : "ready_for_edits"
      });
      console.log("Video reverted to previous version.");
      setSelectedVideo(prev => ({
        ...prev,
        videoURL: newVideoURL,
        videoName: newVideoName,
        status: newVideoURL === selectedVideo.originalVideoURL ? "original" : "ready_for_edits"
      }));
    } catch (err) {
      console.error("Error reverting video:", err);
    }
  };

  const handleSave = async () => {
    if (!selectedVideo || !selectedVideo.videoURL) return;
    try {
      // Show a 5-second loading overlay for the user.
      setShowInitialLoading(true);
      setTimeout(() => {
        setShowInitialLoading(false);
      }, 5000);
  
      // Extract the file name from the selected video's URL.
      const url = new URL(selectedVideo.videoURL);
      const filePath = decodeURIComponent(url.pathname.split("/o/")[1]);
      const fileName = filePath.split("/").pop();
  
      // Call your cloud function that moves the edited video file.
      const moveResponse = await fetch(
        "https://us-central1-editvibe-90968.cloudfunctions.net/moveEditedVideo",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: user.uid,
            fileName: fileName,
          }),
        }
      );
      const moveResult = await moveResponse.json();
      if (moveResult.error) {
        console.error("Move Error:", moveResult.error);
        alert("There was an error moving the video file.");
        return;
      }
  
      // Get the new file name from the returned path.
      const newFileName = moveResult.newPath.split("/").pop();
  
      // IMPORTANT: Get the full download URL for the moved file.
      const newVideoURL = await getDownloadURL(ref(storage, moveResult.newPath));
  
      // Update the Firestore document with the new location and file name.
      await updateDoc(doc(db, "EditVibeToolVideos", selectedVideo.id), {
        status: "ready_for_edits",
        videoURL: newVideoURL,
        firebaseFileName: newFileName,
      });
  
      // Update local state so the sidebar reflects the new video URL.
      setSelectedVideo(prev => ({
        ...prev,
        videoURL: newVideoURL,
        status: "ready_for_edits",
        firebaseFileName: newFileName,
      }));
  
      alert("Video file moved successfully! You can now make further edits.");
    } catch (err) {
      console.error("Error moving video file:", err);
      alert("Something went wrong while moving the video file.");
    }
  };

  const handleContinueSave = async () => {
    // Close the confirmation modal first:
    setShowSaveConfirmModal(false);
    
    if (!selectedVideo || !selectedVideo.videoURL) return;
    try {
      // Show a 5-second loading overlay for the user.
      setShowInitialLoading(true);
      setTimeout(() => {
        setShowInitialLoading(false);
      }, 5000);
    
      // Extract the file name from the selected video's URL.
      const url = new URL(selectedVideo.videoURL);
      const filePath = decodeURIComponent(url.pathname.split("/o/")[1]);
      const fileName = filePath.split("/").pop();
    
      // Call your cloud function that moves the edited video file.
      const moveResponse = await fetch(
        "https://us-central1-editvibe-90968.cloudfunctions.net/moveEditedVideo",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: user.uid,
            fileName: fileName,
          }),
        }
      );
      const moveResult = await moveResponse.json();
      if (moveResult.error) {
        console.error("Move Error:", moveResult.error);
        alert("There was an error moving the video file.");
        return;
      }
    
      // Get the new file name from the returned path.
      const newFileName = moveResult.newPath.split("/").pop();
    
      // IMPORTANT: Get the full download URL for the moved file.
      const newVideoURL = await getDownloadURL(ref(storage, moveResult.newPath));
    
      // Update the Firestore document with the new location and file name.
      await updateDoc(doc(db, "EditVibeToolVideos", selectedVideo.id), {
        status: "ready_for_edits",
        videoURL: newVideoURL,
        firebaseFileName: newFileName,
      });
    
      // Update local state so the sidebar reflects the new video URL.
      setSelectedVideo((prev) => ({
        ...prev,
        videoURL: newVideoURL,
        status: "ready_for_edits",
        firebaseFileName: newFileName,
      }));
    
      // Do not show any alert here.
    } catch (err) {
      console.error("Error moving video file:", err);
      alert("Something went wrong while moving the video file.");
    }
  };
  

  
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [settingsTab, setSettingsTab] = useState('general');

  const [isManagePlanOpen, setIsManagePlanOpen] = useState(false);

  const openSettings = (tab = 'general') => {
    setIsSettingsOpen(true);
    setIsUserMenuOpen(false); // Also close the user menu if it’s open
    setSettingsTab(tab);
  };
  const closeSettings = () => setIsSettingsOpen(false);
  const handleTabClick = (tab) => setSettingsTab(tab);
  
  // Handlers for Manage Plan Overlay
  const openManagePlan = () => {
    setIsManagePlanOpen(true);
    setIsSettingsOpen(false);
  };
  const closeManagePlan = () => setIsManagePlanOpen(false);
  
  /**
   * Example plan purchase function. 
   * If you have an existing handlePurchasePlan from EditVibeLayout, 
   * replicate it here or link it to your existing logic.
   */
  const handlePurchasePlan = async (plan) => {
    try {
      const response = await fetch("https://us-central1-editvibe-90968.cloudfunctions.net/createCheckoutSession", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ plan, userId: user.uid }),
      });
      const data = await response.json();
      if (response.ok) {
        // Redirect to the checkout session URL
        window.location.href = data.checkoutUrl;
      } else {
        alert("Error: " + data.error);
      }
    } catch (err) {
      console.error("Error purchasing plan:", err);
      alert("Error purchasing plan, please try again later.");
    }
  };

  

  return (
    <div className="editvibe-tool editvibe-layout" onClick={() => setMenuOpenFor(null)}>
      {/* SIDEBAR */}
      <aside className="ev-sidebar">
        <div className="sidebar-logo">
          <img src={editvibelogo1} alt="Edit Vibe Logo" className="ev-logo-img" />
        </div>
        <div className="sidebar-section">
          <h2 className="videos-title">Videos</h2>
          <button className="sidebar-add" onClick={openUploadModal}>+</button>
        </div>
        {persistedVideos.map((vid) => (
  <div
    key={vid.id}
    className={`video-item ${!vid.videoURL ? 'nails-video-item' : ''}`}
    onClick={() => handleVideoItemClick(vid)}
    style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
  >
   {vid.status === "processing" ? (
      <div className="spinner loading-placeholder" />
    ) : vid.videoURL ? (
      <div className="ai-stars-icon">
        <div className="ai-orbit ai-orbit1">
          <div className="ai-star" style={{ "--size": "16px" }} />
        </div>
        <div className="ai-orbit ai-orbit2">
          <div className="ai-star" style={{ "--size": "12px" }} />
        </div>
        <div className="ai-orbit ai-orbit3">
          <div className="ai-star" style={{ "--size": "10px" }} />
        </div>
      </div>
    ) : (
      <div className="spinner loading-placeholder" />
    )}
    <div className="video-info">
      <div className="video-name">{vid.videoName}</div>
      <div className="video-status">
        {vid.status === "processing"
          ? "Processing..."
          : (vid.videoURL ? 'Ready, click to watch' : 'Loading...')}
      </div>
    </div>
    {/* Render three-dot button only if not processing and videoURL exists */}
    {vid.status !== "processing" && vid.videoURL && (
      <div
        className="video-dots"
        style={{ marginLeft: 'auto' }}
        onClick={(e) => {
          e.stopPropagation();
          handleMenuToggle(`tool-${vid.id}`, e);
        }}
      >
        •••
      </div>
    )}
  </div>
))}
      </aside>
  
      {/* DELETE MENU RENDERED OUTSIDE THE SIDEBAR */}
      {menuOpenFor && (
        <div
          className="video-menu-outside"
          style={{
            position: 'fixed',
            top: menuPosition.top,
            left: menuPosition.left,
            transform: 'translate(0, -50%)',
            zIndex: 9999,
            backgroundColor: '#fff',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            padding: '8px',
            minWidth: '80px'
          }}
          onClick={(e) => e.stopPropagation()}
        >
           {/* New Download Button */}
           <div
  className="download-button"
  onClick={(e) => {
    e.stopPropagation();
    const videoToDownload = getVideoByMenuKey(menuOpenFor);
    if (videoToDownload && videoToDownload.videoURL) {
      handleDownload(videoToDownload.videoURL, videoToDownload.videoName);
    }
    setMenuOpenFor(null);
  }}
  style={{ marginBottom: '8px', cursor: 'pointer' }}
>
  <IoMdDownload style={{ color: 'black', marginRight: '4px' }} />
  <span style={{ color: '#000' }}>Download</span>
</div>

    {/* Existing Delete Button */}
    <div
  className="delete-button"
  onClick={(e) => {
    e.stopPropagation();
    // Get the video object for the current menu key:
    const video = getVideoByMenuKey(menuOpenFor);
    if (video) {
      setVideoToDelete(video); // store the video to delete
      setShowDeleteModal(true); // open the delete confirmation modal
    }
    setMenuOpenFor(null);
  }}
>
  <FaRegTrashCan style={{ marginRight: '4px', color: '#e33' }} />
  <span style={{ color: '#e33' }}>Delete</span>
</div>
        </div>
      )}
  
      {/* MAIN AREA */}
      <div className="ev-main">
        <header className="ev-header">
          <div className="ev-header-left">
            <div className="ev-app-name" onClick={handleModelClick}>
              EditVibe-CUT <span className="dropdown-arrow">▾</span>
            </div>
            {isModelMenuOpen && (
  <div className="model-dropdown">
    <div className="model-title">Model</div>
    <div className="model-option" onClick={() => selectModel('m1')}>
      <div className="model-info">
        <div className="model-name">
        EditVibe-95 <span className="beta-badge">Research Preview</span>
        </div>
        <div className="model-desc">
        upload, describe, and let EditVibe-95 handle the full edit, no manual work
        </div>
      </div>
      {selectedModel === 'm1' && <div className="checkmark">✓</div>}
    </div>
    <div className="model-option model-disabled" onClick={() => selectModel('m2')}>
      <div className="model-info">
        <div className="model-name">EditVibe-DOS</div>
        <div className="model-desc">
        The next‑gen EditVibe‑95—same full‑edit AI, up to 50% faster processing (under development)
        </div>
      </div>
      {selectedModel === 'm2' && <div className="checkmark">✓</div>}
    </div>
    <div className="model-option" onClick={() => selectModel('editvibeTool')}>
      <div className="model-info">
        <div className="model-name">
        EditVibe-CUT <span className="beta-badge">BETA</span>
        </div>
        <div className="model-desc">
        remove video sections easily using simple prompts
        </div>
      </div>
      
      {selectedModel === 'editvibeTool' && (
    <div className="checkmark">✓</div>
  )}
</div>
                <div className="model-option model-disabled" >
                  <div className="model-info">
                    <div className="model-name">EditVibe-CUT-2</div>
                    <div className="model-desc">
                    Vision‑powered scene removal—cut based on what you see (under development)
                    </div>
                  </div>
      
            </div>
              </div>
            )}



                  {/* ===== SETTINGS OVERLAY ===== */}
      {isSettingsOpen && (
        <div className="overlay">
          <div className="settings-modal">
            <div className="settings-left">
              <h2>Settings</h2>
              <div
                className={`settings-nav-item ${settingsTab === 'general' ? 'active' : ''}`}
                onClick={() => handleTabClick('general')}
              >
                <GoGear className="menu-icon" />
                <span>General</span>
              </div>
              <div
                className={`settings-nav-item ${settingsTab === 'plan' ? 'active' : ''}`}
                onClick={() => handleTabClick('plan')}
              >
                <IoTicketOutline className="menu-icon" />
                <span>My plan</span>
              </div>
            </div>
            <div className="settings-right">
              {settingsTab === 'general' && (
                <>
                  <h2>General</h2>
                  <div className="settings-field">
                    <span className="settings-label">Username</span>
                    <span className="settings-value">{user?.displayName || "N/A"}</span>
                  </div>
                  <div className="settings-field">
                    <span className="settings-label">Email</span>
                    <span className="settings-value">{user?.email || "N/A"}</span>
                  </div>
                </>
              )}
              {settingsTab === 'plan' && (
                <>
                  <h2>{userData?.plan ? userData.plan.toUpperCase() : "FREE"}</h2>
                  <div className="settings-field">
                    <span className="settings-label">Credits</span>
                    <span className="settings-value">
                      {userData?.credits !== undefined ? userData.credits : "Loading..."}
                    </span>
                  </div>
                  <div className="settings-desc">
                    
                  </div>
                  <div className="settings-field">
                    <span className="settings-label">Max Video Duration</span>
                    <span className="settings-value">2mins</span>
                  </div>
                  <div className="settings-desc">
                    Maximum length of the video clip uploaded to EditVibe-CUT
                  </div>
                  <div className="settings-field">
                    <span className="settings-label">Max Resolution</span>
                    <span className="settings-value">1920×1080</span>
                  </div>
                  <div className="settings-field">
                    <span className="settings-label">Max Size File</span>
                    <span className="settings-value">2GB</span>
                  </div>
                </>
              )}
              <div className="settings-buttons">
                <button className="manage-plan-btn" onClick={openManagePlan}>
                  Manage plan
                </button>
                <button className="done-btn" onClick={closeSettings}>Done</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ===== MANAGE PLAN OVERLAY ===== */}
      {isManagePlanOpen && (
        <div className="overlay">
          <div className="manage-plan-modal">
            <button className="close-manage-btn" onClick={closeManagePlan}>×</button>
            <h2 className="manage-title">Upgrade your plan</h2>
            <div className="plans-container">
              <div className="plan-card">
                <h3>Free</h3>
                <p className="plan-price">$0 <span>/ month</span></p>
                <p className="plan-desc">Explore how AI can help you edit your videos</p>
                <button className="current-plan-button" disabled>Your Current Plan</button>
                <ul className="plan-features">
                <li>Access to EditVibe-95</li>
                <li>Access to EditVibe-CUT</li>
                  <li>1,000 credits</li>
                </ul>
              </div>
              <div className="plan-card plus-selected">
                <div className="plan-header">
                  <h3>Plus</h3>
                  <span className="plan-badge">POPULAR</span>
                </div>
                <p className="plan-price">$20 <span>/ month</span></p>
                <p className="plan-desc">Let AI start editing your videos and saving your time</p>
                <button className="plan-action-button plus-btn" onClick={() => handlePurchasePlan("plus")}>
                  Get Plus
                </button>
                <ul className="plan-features">
                <li>Access to EditVibe-95</li>
                <li>Access to EditVibe-CUT</li>
                  <li>2,000 credits</li>
                </ul>
              </div>
              <div className="plan-card">
                <h3>Pro</h3>
                <p className="plan-price">$100 <span>/ month</span></p>
                <p className="plan-desc">
                  Take your video editing production to the next level with EditVibe pro
                </p>
                <button className="plan-action-button black-btn" onClick={() => handlePurchasePlan("pro")}>
                  Get Pro
                </button>
                <ul className="plan-features">
                <li>Access to EditVibe-95</li>
                <li>Access to EditVibe-CUT</li>
                  <li>10,000 credits</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

          </div>
          <div className="ev-header-right">
            <button className="create-btn" onClick={openUploadModal}>+ Create</button>
            <img
              src={user?.photoURL ? user.photoURL : defaultAvatar}
              alt="Profile"
              className="user-avatar"
              onClick={handleAvatarClick}
              style={{ width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer" }}
            />
             {isUserMenuOpen && (
    <div className="user-menu">
      <div className="menu-item" onClick={() => openSettings('general')}>
        <GoGear className="menu-icon" />
        <span>Settings</span>
      </div>

      {/* ——— Tool Tutorials Submenu ——— */}
      <div
        className="menu-item tutorial-tool-parent"
        onClick={() => setToolTutorialOpen(open => !open)}
      >
        <BsTicketPerforated className="menu-icon" />
        <span>Tool tutorials</span>
        {toolTutorialOpen && (
          <div className="tutorial-tool-dropdown">
          <div className="menu-item" onClick={() => showToolTutorial("95")}>
  <PiFilmSlateLight className="menu-icon" />
  <span>EditVibe‑95</span>
</div>
<div className="menu-item" onClick={() => showToolTutorial("cut")}>
  <RiScissorsCutLine className="menu-icon" />
  <span>EditVibe‑CUT</span>
</div>
          </div>
        )}
      </div>

      <div className="menu-item" onClick={() => openSettings('plan')}>
        <IoTicketOutline className="menu-icon" />
        <span>My plan</span>
      </div>
      <hr />
      <div
        className="menu-item logout-btn"
        onClick={() => {
          setIsUserMenuOpen(false);
          logout();
          navigate('/');
        }}
      >
        <LuLogOut className="menu-icon" />
        <span>Logout</span>
      </div>
    </div>
  )}
</div>
        </header>
  
        <main className="ev-body">
  {isUploadOpen && (
    <div className="overlay">
      <div className="upload-modal">
        <div className="upload-header">
          <h2>Upload Video</h2>
          <button className="close-btn" onClick={closeUploadFlow}>×</button>
        </div>
        <div
          className="upload-body"
          onDragOver={(e) => e.preventDefault()}
          onDrop={dropHandler}
        >
          <div className="upload-icon">⬆</div>
          <p>Drag and drop video files to upload</p>
          <input
            type="file"
            accept="video/*"
            id="fileInput"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          <button
            className="select-files-btn"
            onClick={() => document.getElementById('fileInput').click()}
          >
            Select files
          </button>
          {/* New message about file length */}
          <p style={{ marginTop: "8px", fontSize: "0.7rem", color: "#666" }}>
          EditVibe currently supports single uploads only and files up to 2 minutes in length
              </p>
          {uploadError && <p className="error-msg">{uploadError}</p>}
        </div>
      </div>
    </div>
  )}

{isDescribeOpen && (
  <div className="overlay">
    <div className="remove-modal" onClick={e => e.stopPropagation()}>
      {/* close button */}
      <button className="close-btn" onClick={closeUploadFlow}>×</button>

      {/* Title */}
      <h2>EditVibe-CUT</h2>

      {/* Video preview */}
      <div className="video-preview">
  {videoPreview ? (
    <video
      src={videoPreview}
      preload="metadata"
      muted
      // remove controls so it never plays, just shows first frame
      style={{
        width: '100%',
        height: 'auto',
        borderRadius: '8px',
        pointerEvents: 'none',
        backgroundColor: '#000'
      }}
    />
  ) : (
    <div style={{
      width: '100%',
      paddingTop: '56%',      // 16:9 aspect placeholder
      backgroundColor: '#000',
      borderRadius: '8px'
    }}/>
  )}
</div>

      {/* Submit */}
      <button className="submit-btn" onClick={handleSubmitDescription}>
        SUBMIT
      </button>

      {/* Explanation text */}
      <div className="explanation">
      With EditVibe‑CUT, you can remove any spoken word or sentence by typing your instruction e.g. 'remove the part where I say ‘sorry’ or by specifying exact timecodes e.g. 'remove from 00:12 to 00:15'. Vision‑based edits, scene or object removal aren’t supported yet.
</div>
    </div>
  </div>
)}

{!isUploadOpen
  && !isDescribeOpen
  && !selectedVideo
  && (
    <div className="no-videos-container">
      <img src={vidIcon} alt="icons8Plus1" className="no-videos-icon" />
      <p className="no-videos-text">
        Create your first edit by uploading your video file in the{' '}
        <span className="upload-link" onClick={openUploadModal}>Upload</span> section
      </p>
    </div>
  )}
  
  {!isUploadOpen && isVideoOverlayOpen && selectedVideo && (
  <div
    className="video-black-container"
    onClick={e => e.stopPropagation()}    // ← prevent any click here from bubbling up
  >
    <div
      className="video-black-box"
      onClick={e => e.stopPropagation()}    // ← and here too, just in case
    >
      {selectedVideo.status === "processing" ? (
        <div
          style={{
            backgroundColor: "#000",
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",       /* stack spinner + typing text */
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="loading-circle" />

          {/* ← Insert the typing effect here: */}
          <div className="typing-wrapper">
            <div className="ai-stars loading-icon">
              <div className="orbit orbit1">
                <div className="star" style={{ "--size": "16px" }} />
              </div>
              <div className="orbit orbit2">
                <div className="star" style={{ "--size": "12px" }} />
              </div>
              <div className="orbit orbit3">
                <div className="star" style={{ "--size": "10px" }} />
              </div>
            </div>
            <div className="typing-text">
              {typingText}
              <span className="caret" style={{ visibility: isAnimating ? "visible" : "hidden" }} />
            </div>
          </div>
        </div>
      ) : (
        <div className="nails-video-wrapper">
          <div className="nails-video-player">
            <video
              src={selectedVideo.videoURL}
              style={{ width: "100%" }}
              controls
              onClick={e => e.stopPropagation()}  // ← keep clicks on the video from bubbling
            />
          </div>

          {/* final-buttons moved *inside* the wrapper so they sit below the video */}
          {selectedVideo.status === "edited" && (
            <div className="final-buttons">
              <button
                className="delete-btn"
                onClick={e => {
                  e.stopPropagation();
                  setVideoToDelete(selectedVideo);
                  setShowFinalDeleteModal(true);
                }}
              >
                DELETE
              </button>
              <button
                className="save-btn"
                onClick={e => {
                  e.stopPropagation();
                  setShowSaveConfirmModal(true);
                }}
              >
                SAVE
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  </div>
)}

  
{!isUploadOpen
  &&  isVideoOverlayOpen              // ← don’t render until the overlay is gone
  && selectedVideo
  && selectedVideo.status !== "processing"
  && selectedVideo.status !== "edited"   // assuming “edited” means no more edits
  && (
    <div className="text-input-container">
      <textarea
        ref={textareaRef}
        rows="1"
        className="text-input"
        value={textInput}
        onChange={e => setTextInput(e.target.value)}
        placeholder={placeholder}
        maxLength={280}
        onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleTextSubmit();
          }
        }}
      />
      <button
        className="submit-btn"
        disabled={!textInput.trim()}
        onClick={handleTextSubmit}
        aria-label="Submit edit"
      >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10 16V4M6 8l4-4 4 4" />
      </svg>
    </button>
  </div>
)}


{showSaveConfirmModal && (
  <div className="overlay" onClick={() => setShowSaveConfirmModal(false)}>
    <div
      className="confirmation-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <h2 style={{ marginBottom: "8px", fontSize: "1rem", fontWeight: "600" }}>
        Would you like to save this new version?
      </h2>
      <div className="modal-buttons">
        <button 
          className="cancel"
          onClick={() => setShowSaveConfirmModal(false)}
        >
          Cancel
        </button>
        <button 
          className="continue"
          onClick={handleContinueSave}
        >
          Continue
        </button>
      </div>
    </div>
  </div>
)}
  

  
          {isSubmitting && (
            <div className="overlay">
              <div className="loading-modal">
                <div className="loading-indicator">
                  <div className="spinner"></div>
                  <p>Uploading video...</p>
                </div>
              </div>
            </div>
          )}
  
          {showInitialLoading && (
            <div className="overlay">
              <div className="loading-modal">
                <div className="loading-indicator">
                  <div className="spinner"></div>
                  <p>Processing your request...</p>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
      {showTranscriptionErrorModal && (
  <div className="overlay" onClick={handleCloseTranscriptionErrorModal}>
    <div
      className="transcription-error-modal"
      onClick={(e) => e.stopPropagation()}  // Prevent modal dismissal when clicking inside
      style={{
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "16px",
        width: "300px",
        margin: "0 auto"
      }}
    >
      <h2 style={{ marginBottom: "8px", fontSize: "1rem", fontWeight: "600" }}>
        It seems like EditVibe is still analyzing this video.
      </h2>
      <p style={{ marginBottom: "16px", fontSize: "0.95rem", color: "#333" }}>
        Give it a try in a couple of seconds and try again.
      </p>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <button
          className="continue-btn"
          onClick={handleCloseTranscriptionErrorModal}
          style={{
            backgroundColor: "#e33",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "8px 16px",
            cursor: "pointer"
          }}
        >
          Continue
        </button>
      </div>
    </div>
  </div>
)}
{showTimecodeErrorModal && (
  <div className="overlay" onClick={handleCloseTimecodeErrorModal}>
    <div
      className="transcription-error-modal"
      onClick={(e) => e.stopPropagation()}  // Prevent clicks inside the modal from closing it
      style={{
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "16px",
        width: "300px",
        margin: "0 auto"
      }}
    >
      <h2 style={{ marginBottom: "8px", fontSize: "1rem", fontWeight: "600" }}>
        Edit request failed
      </h2>
      <p style={{ marginBottom: "16px", fontSize: "0.95rem", color: "#333" }}>
        The edit requested was not able to be done.
        <br />
        Please specify words said in the video or be more precise with the timecodes.
      </p>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <button
          className="continue-btn"
          onClick={handleCloseTimecodeErrorModal}
          style={{
            backgroundColor: "#e33",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "8px 16px",
            cursor: "pointer"
          }}
        >
          Continue
        </button>
      </div>
    </div>
  </div>
)}
 {/* DELETE CONFIRMATION MODAL */}
 {showDeleteModal && videoToDelete && (
    <div className="overlay" onClick={handleCancelDelete}>
      <div
        className="delete-confirm-modal"
        onClick={(e) => e.stopPropagation()} 
      >
        <h2 style={{ marginBottom: '8px', fontSize: '1rem', fontWeight: '600' }}>
        Delete this file?
        </h2>
        <p style={{ marginBottom: '16px', fontSize: '0.95rem', color: '#333' }}>
        You're about to permanently delete <strong>{videoToDelete.videoName}</strong>.
          <br />
          This action can’t be undone.
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button 
            className="cancel-btn" 
            onClick={handleCancelDelete}
            style={{
              backgroundColor: '#f0f0f0',
              color: '#555',
              border: 'none',
              borderRadius: '4px',
              padding: '8px 16px',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            className="confirm-delete-btn"
            onClick={handleConfirmDelete}
            style={{
              backgroundColor: '#e33',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '8px 16px',
              cursor: 'pointer',
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
      )}

{toolTutorialModal && (
  <div
    className="tutorial-modal-backdrop"
    onClick={closeToolTutorialModal}
  >
    <div
      className="tutorial-modal"
      onClick={e => e.stopPropagation()}
    >
      <div className="tutorial-video-wrapper">
        <video
          src={
            toolTutorialModal === "95"
              ? editvibe95tutorial
              : editvibecuttutorial
          }
          controls
          className="tutorial-video"
        />
      </div>
      <div className="tutorial-footer">
        <h3 className="tutorial-title">
          {toolTutorialModal === "95"
            ? "EditVibe‑95"
            : "EditVibe‑CUT"}
        </h3>
        <button
          className="tutorial-close-btn"
          onClick={closeToolTutorialModal}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

     {showFinalDeleteModal && videoToDelete && (
        <div className="overlay" onClick={handleCancelFinalDelete}>
          <div
            className="delete-confirm-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ marginBottom: '8px', fontSize: '1rem', fontWeight: '600' }}>
              This will revert {videoToDelete.videoName}
            </h2>
            <p style={{ marginBottom: '16px', fontSize: '0.95rem', color: '#333' }}>
              If you choose to continue, the edited version will be replaced by the previous version.
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
              <button 
                className="cancel-btn" 
                onClick={handleCancelFinalDelete}
                style={{
                  backgroundColor: '#f0f0f0',
                  color: '#555',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '8px 16px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                className="confirm-delete-btn"
                onClick={() => {
                  handleDelete(videoToDelete.id);
                  setShowFinalDeleteModal(false);
                }}
                style={{
                  backgroundColor: '#e33',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '8px 16px',
                  cursor: 'pointer',
                }}
              >
                Revert
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


  
export default EditVibeTool;